import {
  Button,
  Dialog,
  ListItem,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "@sellar-io/components";
import { useState } from "react";
import { InfiniteList } from "../../../components/infiniteLoading/InfiniteList";
import { twMerge } from "tailwind-merge";
import { pluralize } from "@sellar-io/common";
import { useAvailabilityTierList } from "../../../hooks/api/v2/availabilityTier/useAvailabilityTierList";

export const AssignProductCatalogueDialog = ({
  active,
  setActive,
  loading,
  availabilityTierId,
  onClick,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
  loading: boolean;
  availabilityTierId: number | null;
  onClick: (id: number | null) => void;
}) => {
  const [selectedAvailabilityTierId, setSelectedAvailabilityTierId] = useState<
    number | null
  >(availabilityTierId);

  const onSubmit = () => {
    onClick(selectedAvailabilityTierId);
  };

  return (
    <Dialog active={active} onDismiss={() => setActive(false)}>
      <DialogNavigation
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={() => setActive(false)}
        title="Assign product catalogue"
        description="Your customer can be assigned any of the product catalogues you have defined"
      />
      <DialogContent className="flex min-h-75 flex-col gap-4">
        {active && (
          <Content
            selectedAvailabilityTierId={selectedAvailabilityTierId}
            setSelectedAvailabilityTierId={setSelectedAvailabilityTierId}
          />
        )}
      </DialogContent>
      <DialogCTA>
        <Button onClick={onSubmit} loading={loading}>
          Confirm
        </Button>
      </DialogCTA>
    </Dialog>
  );
};

const Content = ({
  selectedAvailabilityTierId,
  setSelectedAvailabilityTierId,
}: {
  selectedAvailabilityTierId: number | null;
  setSelectedAvailabilityTierId: (id: number | null) => void;
}) => {
  const availabilityTiersQuery = useAvailabilityTierList({
    limit: 10,
    includeCounts: true,
  });

  const availabilityTiers = availabilityTiersQuery.data?.pages.flat() ?? [];

  return (
    <InfiniteList
      query={availabilityTiersQuery}
      className="mb-8 flex flex-col divide-y overflow-hidden rounded-lg border border-zinc-300"
    >
      {availabilityTiers.map((availabilityTier) => {
        const selected = availabilityTier.id === selectedAvailabilityTierId;

        return (
          <ListItem
            key={availabilityTier.id}
            title={availabilityTier.name}
            subtitle={
              availabilityTier.hiddenProducts === null
                ? undefined
                : `${availabilityTier.hiddenProducts} ${pluralize("product", availabilityTier.hiddenProducts)} hidden`
            }
            icon={selected ? "CHECK" : "BOOK_OUTLINE"}
            onClick={() => {
              setSelectedAvailabilityTierId(
                selected ? null : availabilityTier.id,
              );
            }}
            className={twMerge(
              "bg-white p-4 hover:bg-zinc-50",
              selected ? "bg-zinc-50" : "",
            )}
            iconClassName={selected ? "border-zinc-800 bg-zinc-200" : ""}
          />
        );
      })}
    </InfiniteList>
  );
};
